/* eslint-disable */
/* prettier-ignore */

/**
 * This file is auto-generated with openapi2ts (@mittwald/openapi-to-typescript)
 */

import { KyClient } from "@mittwald/api-client/dist/http/KyClient.js";
import { Client } from "@mittwald/api-client/dist/http/Client.js";
import { RequestFunction } from "@mittwald/api-client/dist/OperationDescriptor.js";
import { OperationDescriptor } from "@mittwald/api-client/dist/OperationDescriptor.js";

/**
 * ====================================
 * Types
 * ====================================
 */
export declare module MittwaldInternalApi {
  namespace Paths {
    namespace V2_Signup_Impersonate {
      namespace Post {
        namespace Parameters {
          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }

          interface RequestBody {
            userId?: string;
          }
        }

        namespace Responses {
          namespace $200 {
            namespace Content {
              interface Application_Json {
                expires?: number;
                token: string;
              }
            }
          }

          namespace $400 {
            namespace Content {
              type Application_Json =
                MittwaldInternalApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace $403 {
            namespace Content {
              type Application_Json =
                MittwaldInternalApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrors;
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldInternalApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }

    namespace Internal_V2_Users {
      namespace Get {
        namespace Parameters {
          interface Query {
            limit?: number;
            skip?: number;
            page?: number;
            email?: string;
            firstName?: string;
            lastName?: string;
            userSource?: "ldap" | "signup";
          }

          interface Header {
            "x-access-token"?: string;
            Accept?: "application/json";
          }
        }

        namespace Responses {
          namespace $200 {
            interface Headers {
              "X-Pagination-Limit"?: number;
              "X-Pagination-Page"?: number;
              "X-Pagination-Skip"?: number;
              "X-Pagination-TotalCount"?: number;
            }

            namespace Content {
              type Application_Json =
                MittwaldInternalApi.Components.Schemas.De_Mittwald_V1_User_User[];
            }
          }

          namespace Default {
            namespace Content {
              type Application_Json =
                MittwaldInternalApi.Components.Schemas.De_Mittwald_V1_Commons_Error;
            }
          }
        }
      }
    }
  }

  namespace Components {
    namespace Schemas {
      interface De_Mittwald_V1_Signup_DomainError {
        info?: {};
        message: string;
        name: string;
      }

      interface De_Mittwald_V1_User_User {
        avatarRef?: string;
        email?: string;
        person: MittwaldInternalApi.Components.Schemas.De_Mittwald_V1_Signup_Person;
        phoneNumber?: string;
        userId: string;
      }

      interface De_Mittwald_V1_Signup_Person {
        firstName: string;
        lastName: string;
        title?: "other" | "mr" | "ms";
      }

      interface De_Mittwald_V1_Commons_Error {
        message: string;
        type: string;
      }

      interface De_Mittwald_V1_Commons_ValidationErrorSchema {
        message: string;
        path: string;
        type: string;
        context?: {
          [a: string]: any;
        };
      }

      interface De_Mittwald_V1_Commons_ValidationErrors {
        type: "ValidationError";
        message?: string;
        validationErrors: MittwaldInternalApi.Components.Schemas.De_Mittwald_V1_Commons_ValidationErrorSchema[];
      }
    }

    namespace Parameters {}

    namespace Responses {
      type De_Mittwald_V1_Signup_InternalServerError = any;

      type De_Mittwald_V1_Signup_NoValidAccessTokenError = any;

      type De_Mittwald_V1_Commons_DefaultError = any;

      type De_Mittwald_V1_Commons_NotFoundError = any;

      type De_Mittwald_V1_Commons_RateLimitError = any;

      type De_Mittwald_V1_Commons_ValidationError = any;
    }

    namespace RequestBodies {}
  }

  namespace Definitions {}
}

/**
 * ====================================
 * Descriptors
 * ====================================
 */

export const userImpersonate: OperationDescriptor<
  {
    requestBody: MittwaldInternalApi.Paths.V2_Signup_Impersonate.Post.Parameters.RequestBody;

    header: MittwaldInternalApi.Paths.V2_Signup_Impersonate.Post.Parameters.Header;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldInternalApi.Paths.V2_Signup_Impersonate.Post.Responses.$200.Content.Application_Json;
    })
  | ({ status: 400 } & {
      mediaType: "application/json";
      content: MittwaldInternalApi.Paths.V2_Signup_Impersonate.Post.Responses.$400.Content.Application_Json;
    })
  | ({ status: 403 } & {
      mediaType: "application/json";
      content: MittwaldInternalApi.Paths.V2_Signup_Impersonate.Post.Responses.$403.Content.Application_Json;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldInternalApi.Paths.V2_Signup_Impersonate.Post.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/v2/signup/impersonate",
  method: "post",
  operationId: "userImpersonate",
};

export const userListAllUsers: OperationDescriptor<
  {
    header: MittwaldInternalApi.Paths.Internal_V2_Users.Get.Parameters.Header;

    query: MittwaldInternalApi.Paths.Internal_V2_Users.Get.Parameters.Query;
  },
  | ({ status: 200 } & {
      mediaType: "application/json";
      content: MittwaldInternalApi.Paths.Internal_V2_Users.Get.Responses.$200.Content.Application_Json;

      headers: MittwaldInternalApi.Paths.Internal_V2_Users.Get.Responses.$200.Headers;
    })
  | ({ status: 0 } & {
      mediaType: "application/json";
      content: MittwaldInternalApi.Paths.Internal_V2_Users.Get.Responses.Default.Content.Application_Json;
    })
> = {
  path: "/internal-v2/users",
  method: "get",
  operationId: "userListAllUsers",
};

/**
 * ====================================
 * Client
 * ====================================
 */
export class MittwaldInternalApiClient {
  private static instance: MittwaldInternalApiClient | undefined;

  public static getInstance(): MittwaldInternalApiClient {
    const requireClientInstanceMethod = (
      methodName: string | symbol
    ): Function => {
      const client = MittwaldInternalApiClient.instance as
        | undefined
        | Record<string | symbol, any>;

      if (!client) {
        throw new Error(
          "ApiClientInstanceNotSet: API-Client-instance must be set before using hooks. Use MittwaldInternalApiClient.setInstance()."
        );
      }

      if (!(methodName in client)) {
        throw new Error(
          `InvalidMethodCall: Could not find method ${String(
            methodName
          )} in MittwaldInternalApiClient`
        );
      }

      const method = client[methodName];

      if (typeof method !== "function") {
        throw new Error(
          `InvalidMethodCall: ${String(
            methodName
          )} in MittwaldInternalApiClient is not a function`
        );
      }

      return method;
    };

    /**
     * Catch access to all props and return proxy method that proxies
     * calls to the underlying client instance, while accessing the instance
     * at call-time.
     */
    const lazyAccessingClientInstanceHandler: ProxyHandler<MittwaldInternalApiClient> =
      {
        get(client, prop) {
          return (...params: any[]) =>
            requireClientInstanceMethod(prop)(...params);
        },
      };

    return new Proxy(
      {} as MittwaldInternalApiClient,
      lazyAccessingClientInstanceHandler
    );
  }

  public static setInstance(client: MittwaldInternalApiClient): void {
    MittwaldInternalApiClient.instance = client;
  }

  public userImpersonate: RequestFunction<typeof userImpersonate>;

  public userListAllUsers: RequestFunction<typeof userListAllUsers>;

  public constructor(clientOrUrl: Client | string) {
    const client =
      typeof clientOrUrl === "string"
        ? new KyClient({ ky: { prefixUrl: clientOrUrl } })
        : clientOrUrl;

    this.userImpersonate = client.requestFunctionFactory(userImpersonate);

    this.userListAllUsers = client.requestFunctionFactory(userListAllUsers);
  }
}

/**
 * ====================================
 * API
 * ====================================
 */

import { createGetApiOperationResource } from "@mittwald/flow-lib/dist/resources/ApiOperationResource/createGetApiOperationResource";

export const mittwaldInternalApi = {
  userImpersonate: {
    getResource: createGetApiOperationResource(
      userImpersonate,
      MittwaldInternalApiClient.getInstance().userImpersonate
    ),

    request: MittwaldInternalApiClient.getInstance().userImpersonate,
    descriptor: userImpersonate,
  },

  userListAllUsers: {
    getResource: createGetApiOperationResource(
      userListAllUsers,
      MittwaldInternalApiClient.getInstance().userListAllUsers
    ),

    request: MittwaldInternalApiClient.getInstance().userListAllUsers,
    descriptor: userListAllUsers,
  },
};
